import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { CSVReader } from 'react-papaparse';
import { confirmAlert } from 'react-confirm-alert';
import { Backup , DeleteOutline } from 'styled-icons/material';
import database from '../../../model/firebase/firebase';
import { ShowNotification } from "../../Notifications";
import { fetchDataPostAsync } from '../../../model/axios/fetchs';

const re =
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

function ImportUsers({ className }) {
  const [state, setState] = React.useState({
    platformName: '',
    currentSection: true,
    thereIsEmails: false,
    thereIsID: false,
    emailsArray: [],
    idsArray: [],
    individualEmail: '',
    individualID: '',
    currentEmails: [],
  });

  const { platform } = useSelector((state) => state);

  const buttonRef = React.createRef();

  const handleOpenDialog = (e) => {
    if (buttonRef.current) {
      buttonRef.current.open(e);
    }
  };

  const handleOnFileLoad = async (data) => {
    setState((prev) => ({ ...prev, emailsArray: [] }));

    const emails = [];
    data.map((c) => {
      // console.log(c)
      if (re.test(c.data[0])) {
        emails.push(c.data[0]);
      }
    });

    setState((prev) => ({
      ...prev,
      thereIsEmails: true,
      emailsArray: emails,
    }));
  };

  const handleOnError = (err, file, inputElem, reason) => {
    console.log(err, file, inputElem, reason);
  };

  const handleOnRemoveFile = (data) => {
    setState((prev) => ({ ...prev, thereIsEmails: false, emailsArray: [] }));
  };

  const handleRemoveFile = (e) => {
    if (buttonRef.current) {
      buttonRef.current.removeFile(e);
    }
  };

  const confirmSaveData = () => {
    if (state.emailsArray.length > 9) {
      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <div className="custom-ui">
              <p className="job-title">
                ¿Estas seguro de agregar
                <strong>{` ${state.emailsArray.length}`} </strong> nuevos registros a la base de datos?
              </p>
              <p className="text">
                Te recordamos que para tener un correcto funcionamiento de la plataforma debes de realizar este proceso
                solo una vez al mes y no insertar registros duplicados.
              </p>
              <button className="confirm-button-no" onClick={onClose}>
                Cancelar
              </button>
              <button
                className="confirm-button-yes"
                onClick={() => {
                  saveUsersEmails();
                  onClose();
                }}>
                Importar
              </button>
            </div>
          );
        },
      });
    } else {
      ShowNotification('warning', 'El minimo de registros que puedes agregar son 10', 'Registros insuficientes');
    }
  };

  const saveUsersEmails = async () => {
    if (state.thereIsEmails) {
      const doc = await database
        .collection(platform.platformName)
        .doc('data')
        .collection('ImportedEmails')
        .doc('data')
        .get();
      if (doc?.exists) {
        const updateEmails = (doc?.data()?.authorizedEmails || []).concat(state.emailsArray);
        await database
          .collection(platform.platformName)
          .doc('data')
          .collection('ImportedEmails')
          .doc('data')
          .update({ authorizedEmails: updateEmails });
        const sendable = {
          platformName: platform.platformFullName,
          platformURL: platform.platformURL,
          email: state.emailsArray,
        };
        await fetchDataPostAsync('multipleNotificationUsers', sendable);
        ShowNotification('success', 'Se importaron todos los correos de manera correcta', 'Todo listo!');
      } else {
        await database
          .collection(platform.platformName)
          .doc('data')
          .collection('ImportedEmails')
          .doc('data')
          .set({ authorizedEmails: state.emailsArray });
        const sendable = {
          platformName: platform.platformFullName,
          platformURL: platform.platformURL,
          email: state.emailsArray,
        };
        await fetchDataPostAsync('multipleNotificationUsers', sendable);
      }
      buttonRef.current.removeFile();
    } else {
      ShowNotification('warning', 'No se ha seleccionado ningún archivo para importar', '¡Atención!');
    }
  };

  const addIndividualEmail = async () => {
    const doc = database.collection(platform.platformName).doc('data').collection('ImportedEmails').doc('data');
    const data = (await doc.get()).data();
    const { exists } = await doc.get();
    const emails = exists ? data.authorizedEmails : [];
    emails.push(state.individualEmail);
    await database
      .collection(platform.platformName)
      .doc('data')
      .collection('ImportedEmails')
      .doc('data')
      .set({ authorizedEmails: emails });
    const sendable = {
      platformName: platform.platformFullName,
      platformURL: platform.platformURL,
      email: [state.individualEmail],
    };
    await fetchDataPostAsync('multipleNotificationUsers', sendable);
    ShowNotification('success', 'Se agregó correctamente', '¡Listo!');
  };

  const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  return (
    <div className={`container ${className}`}>
      <div className="a-main-card">
        <div className="adt">
          <div className="ap-container">
            <div className="sub-section-container-show">
              <CSVReader
                ref={buttonRef}
                onFileLoad={handleOnFileLoad}
                onError={handleOnError}
                onRemoveFile={handleOnRemoveFile}>
                {({ file }) => (
                  <div>
                    <aside className="upload-file-users-area">
                      <button type="button" onClick={handleOpenDialog} className="upload-file-users-button-file">
                        <Backup size={20} color="red" /> Seleccionar archivo
                      </button>
                      {file && file.name && file && file.name}
                      <div className="upload-file-users-area-delete">{file && file.name}</div>
                      <button className="upload-file-users-button" onClick={handleRemoveFile}>
                        Eliminar <DeleteOutline size={20} color="red" />
                      </button>
                    </aside>
                  </div>
                )}
              </CSVReader>
              {state.thereIsEmails ? (
                <p className="upload-file-warning-text">
                  {`Se detectaron ${numberWithCommas(state.emailsArray.length)} 
                                    registros en este archivo`}
                </p>
              ) : null}
              <button className="upload-file-button-set-data" onClick={confirmSaveData}>
                Importar ahora
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default styled(ImportUsers)`
  .upload-file-users-area {
    display: flex;
    width: 100%;
    padding: 10px;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
  }
  .upload-file-users-area-delete {
    width: 20%;
    font-size: 1.4rem;
    display: inline-block;
    padding: 5px;
  }
  .upload-file-users-button {
    width: 20%;
    font-size: 1.6rem;
    background-color: white;
    color: red;
    font-weight: 500;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .upload-file-users-button-file {
    width: 30%;
    font-size: 1.6rem;
    background-color: white;
    color: var(--text-black);
    font-weight: 600;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .upload-file-warning-text {
    font-size: 2rem;
    font-weight: 300;
    margin-top: 20px;
    margin-bottom: 20px;
    display: block;
    width: 70%;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
  }
  .upload-file-button-set-data {
    color: #ffffff;
    width: 30%;
    height: auto;
    padding: 7px 20px;
    font-size: 1.6rem !important;
    border-radius: 5px;
    background-color: #5373fc;
    margin: 50px auto;
  }
  .individual-import-section {
    font-size: 1.4rem;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    margin-bottom: 20px;
    padding: 20px;
  }
  .individual-import-input {
    font-size: 1.5rem;
    margin-left: 15px;
    margin-right: 15px;
    padding-left: 3px;
    padding-right: 3px;
    padding-top: 6px;
    padding-bottom: 6px;
    width: 30%;
  }
  .sub-section-container-show {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    padding: 20px;
    margin: 35px auto;
  }
  .confirm-button-no {
    color: #ffffff;
    padding: 7px 35px;
    font-size: 1.7rem !important;
    border-radius: 5px;
    background-color: #f63942;
    margin: 15px 20px;
  }
  .confirm-button-yes {
    color: #ffffff;
    padding: 7px 35px;
    font-size: 1.7rem !important;
    border-radius: 5px;
    background-color: #5373fc;
    margin: 15px 20px;
  }
`;
